import React from 'react';
import { cn } from '@/lib/utils';

interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ href, children, className }) => {
  return (
    <a
      href={href}
      className={cn(
        // Visually hidden by default
        "sr-only focus:not-sr-only",
        // Visible when focused
        "focus:absolute focus:top-4 focus:left-4 focus:z-50",
        // Styling when visible
        "focus:bg-primary focus:text-primary-foreground",
        "focus:px-4 focus:py-2 focus:rounded-md",
        "focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring",
        // Ensure minimum touch target size
        "focus:min-h-[44px] focus:min-w-[44px]",
        "focus:flex focus:items-center focus:justify-center",
        // Smooth transitions
        "transition-all duration-200",
        className
      )}
      onKeyDown={(e) => {
        // Allow both Enter and Space to activate
        if (e.key === ' ') {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
    >
      {children}
    </a>
  );
};

export { SkipLink };